/* Victoria Rockera — Cart UI tweaks
   1) Inyecta el header "PRODUCTO / CANTIDAD / TOTAL" en /cart desktop.
   2) Mantiene el botón "−" sin opacity baja.
*/
(function () {
  'use strict';

  function unlockMinusButtons() {
    document.querySelectorAll('.quantity-minus, [name="minus"]').forEach(function (b) {
      b.style.pointerEvents = 'auto';
      b.style.opacity = '';
      b.style.cursor = 'pointer';
    });
  }

  function injectHeader() {
    /* Solo en cart-page (no en drawer) y solo en desktop ≥ 768px */
    if (document.documentElement.getAttribute('data-template') !== 'cart' &&
        document.body.getAttribute('data-template') !== 'cart' &&
        !document.querySelector('[data-template="cart"]')) {
      return;
    }
    if (window.matchMedia('(max-width: 767px)').matches) return;

    var wrapper = document.querySelector('.cart-items__wrapper');
    if (!wrapper) return;
    if (wrapper.querySelector('.vr-cart-header')) return;

    var table = wrapper.querySelector('.cart-items__table');
    if (!table) return;

    var header = document.createElement('div');
    header.className = 'vr-cart-header';
    header.setAttribute('aria-hidden', 'true');
    header.innerHTML =
      '<span class="vr-cart-header__col vr-cart-header__col--product">Producto</span>' +
      '<span class="vr-cart-header__col vr-cart-header__col--qty">Cantidad</span>' +
      '<span class="vr-cart-header__col vr-cart-header__col--total">Total</span>';

    var form = wrapper.querySelector('form.cart-form');
    if (form) {
      form.insertBefore(header, form.firstChild);
    } else {
      wrapper.insertBefore(header, table.parentNode || table);
    }
  }

  function initAll() {
    unlockMinusButtons();
    injectHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var observer = new MutationObserver(initAll);
  observer.observe(document.body, { childList: true, subtree: true });
})();
